import React from "react";
import WhiteButton from "./WhiteButton";
import { ArrowRight } from "lucide-react";

const HorizontalScrollSection = ({
  className = "",
  buttonTitle = "Click Me",
  onClick,
  child,
}) => {
  return (
    <div className={`relative ${className}`}>
      <div className="relative overflow-hidden">
        <div
          className="overflow-x-auto scroll-smooth scrollbar-hidden no-scrollbar"
          style={{
            scrollbarWidth: "none",
            "-ms-overflow-style": "none",
          }}
        >
          <div className="inline-flex space-x-4 px-4">{child}</div>
        </div>
        {buttonTitle && (
          <div className="flex items-center justify-center mt-12">
            <WhiteButton
              text={buttonTitle}
              icon={<ArrowRight />}
              onClick={onClick}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default HorizontalScrollSection;
